/*
ExternalCenters

This class is called in each section of the Homepage.
When called with an argument, it returns an object holding the aggregated data from all centers.
Example:

const extData = new ExternalCenters("gender");
> {male: 1999, female: 1353, unknown: 0}

This data is used to patch the website frontend by adding the values to the highcharts configuration:

const seriesGeneral = this.props.data.generals_genders_distributions.map(
  data => ({name: data.gender, data: [data.count += extData[data.gender]]})
);
 */

export default class ExternalCenters {
    constructor(key = false) {
        const countries = require("./external_data");
        // If no subset is selected, return plain json data
        if (!(key)){return countries;}
        // Else, sum up data of all countries and return selected subset
        this[key] = {};
        for (const country in countries) {
            for (const property in countries[country][key]){
                if (!(this[key].hasOwnProperty(property))){
                    this[key][property] = 0;
                }
                this[key][property] += countries[country][key][property];
            }
        }
        return this[key];
    }
};



// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/ExternalCenters.js